module.exports = __webpack_public_path__ + "static/media/icon_nagi01024c915efecdf80afb6bbb20bdd1a1.webp";